import Component from './component';
import { connect } from 'react-redux';
import { getAppSettings } from '~/core/state/app-settings/selectors';
import { setAppSettings } from '~/core/state/app-settings/actions';

function mapStateToProps(state) {
    const settings = getAppSettings(state)
        .filter(value => typeof value === 'boolean')
        .toArray();

    return {
        settings
    };
}

function mapDispatchToProps(dispatch) {
    return {
        changeSetting: (key, value) => dispatch(setAppSettings({ [key]: value }))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./src/components/dev-tools/index.js